import { LoginForm } from '@modules/Login/forms/LoginForm.tsx';
import useDocumentTitle from "@/hooks/useDocumentTitle";

export function Login() {
  useDocumentTitle("Login");
  return (
    <div className="text-white h-full w-full flex justify-center items-center bg-cover">
      <LoginForm />
    </div>
  );
}
